import React, { useEffect, useState } from 'react';

interface MiniNotchVisualizerProps {
  className?: string;
}

export const MiniNotchVisualizer: React.FC<MiniNotchVisualizerProps> = ({ className = '' }) => {
  const [animationFrame, setAnimationFrame] = useState(0);
  
  useEffect(() => {
    const interval = setInterval(() => {
      setAnimationFrame((prev) => (prev + 1) % 60); // 60 frame cycle
    }, 100); // Update every 100ms for smooth animation
    
    return () => clearInterval(interval);
  }, []);
  
  // Generate bar heights with center notch
  const bars = Array.from({ length: 15 }, (_, i) => {
    const isNotch = i === 7; // Center bar
    if (isNotch) return 0.15; // Notch is very low
    
    // Create wave pattern
    const waveOffset = Math.sin((animationFrame / 10) + (i * 0.5)) * 0.2;
    const baseHeight = 0.6 + waveOffset;
    
    // Bars near notch are slightly lower
    const distanceFromNotch = Math.abs(i - 7);
    const notchInfluence = distanceFromNotch <= 2 ? (3 - distanceFromNotch) * 0.15 : 0;
    
    return Math.max(0.3, baseHeight - notchInfluence);
  });
  
  return (
    <div className={`flex items-end justify-center gap-1 h-20 ${className}`}>
      {bars.map((height, i) => {
        const isNotch = i === 7;
        return (
          <div
            key={i}
            className="w-3 rounded-t-sm transition-all duration-300"
            style={{
              height: `${height * 100}%`,
              backgroundColor: isNotch ? 'rgba(236, 72, 153, 0.9)' : 'rgba(255, 255, 255, 0.9)',
              boxShadow: isNotch ? '0 0 12px rgba(236, 72, 153, 0.6)' : 'none'
            }}
          />
        );
      })}
    </div>
  );
};